import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";

export const TASK_STATUS = {
  pending: { label: "Pendiente", dot: "bg-muted-foreground", text: "text-muted-foreground", soft: "bg-muted text-muted-foreground" },
  in_progress: { label: "En curso", dot: "bg-chart-4", text: "text-chart-4", soft: "bg-chart-4/12 text-chart-4" },
  review: { label: "Revisión", dot: "bg-gold", text: "text-gold-foreground", soft: "bg-gold/15 text-[#a9741c] dark:text-gold" },
  done: { label: "Hecho", dot: "bg-primary", text: "text-primary", soft: "bg-primary/12 text-primary" },
};

export const PROJECT_STATUS = {
  active: { label: "Activo", soft: "bg-primary/12 text-primary" },
  on_hold: { label: "En pausa", soft: "bg-gold/15 text-[#a9741c] dark:text-gold" },
  done: { label: "Finalizado", soft: "bg-muted text-muted-foreground" },
  archived: { label: "Archivado", soft: "bg-muted text-muted-foreground" },
};

export const PRIORITY = {
  low: { label: "Baja", soft: "bg-muted text-muted-foreground" },
  medium: { label: "Media", soft: "bg-chart-4/12 text-chart-4" },
  high: { label: "Alta", soft: "bg-destructive/12 text-destructive" },
};

export function StatusBadge({ status }) {
  const s = TASK_STATUS[status] || TASK_STATUS.pending;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium", s.soft)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
}

export function ProjectStatusBadge({ status }) {
  const s = PROJECT_STATUS[status] || PROJECT_STATUS.active;
  return <Badge variant="outline" className={cn("border-transparent font-medium", s.soft)}>{s.label}</Badge>;
}

export function PriorityBadge({ priority }) {
  const p = PRIORITY[priority] || PRIORITY.medium;
  return <span className={cn("inline-flex rounded px-1.5 py-0.5 text-[11px] font-semibold", p.soft)}>{p.label}</span>;
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="font-heading font-bold text-2xl sm:text-[28px] tracking-tight leading-none">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function budgetColor(pct) {
  if (pct >= 100) return "bg-destructive";
  if (pct >= 80) return "bg-gold";
  return "bg-primary";
}
